/**
 * Make all given keys required while making all the other properties optional
 */
export type RequireOnly<T, Keys extends keyof T> = Partial<T> &
  Pick<WithRequired<T, Keys>, Keys>;

/**
 * Make all given keys required, without touching the rest of the properties
 */
export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export type Values<D extends object> = D[keyof D];

export type UnionToIntersection<U> = (
  U extends any ? (x: U) => void : never
) extends (x: infer I) => void
  ? I
  : never;

export type Prettify<T> = {
  [K in keyof T]: T[K];
};

export type NonEmptyArray<T> = [T, ...T[]];

export function assertNonEmptyArray<T>(
  array: T[],
  message = 'Array must not be empty',
): asserts array is NonEmptyArray<T> {
  if (array.length === 0) {
    throw new Error(message);
  }
}
